import axios from 'axios';
import { API_URL } from '../utils/constants';

export const authAPI = {
  // Email/Password Login
  login: async (email, password, deviceToken = '', deviceId = '') => {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('deviceToken', deviceToken);
    formData.append('deviceId', deviceId);
    formData.append('device_type', 'web');

    const response = await axios.post(`${API_URL}/login`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Register
  register: async (userData) => {
    const formData = new FormData();
    formData.append('username', userData.username || userData.name);
    formData.append('address', userData.address || '');
    formData.append('email', userData.email);
    formData.append('phone', userData.phone || userData.mobile);
    formData.append('device_type', 'web');
    formData.append('pass', userData.password || userData.pass);

    const response = await axios.post(`${API_URL}/register`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Send OTP
  sendOTP: async (mobile) => {
    const formData = new FormData();
    formData.append('mobile', mobile);

    const response = await axios.post(`${API_URL}/sendOTP`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Verify OTP Login
  verifyOTP: async (mobile, otp, deviceId = '', deviceToken = '') => {
    const formData = new FormData();
    formData.append('mobile', mobile);
    formData.append('otp', otp);
    formData.append('deviceId', deviceId);
    formData.append('fcm_token', deviceToken);

    const response = await axios.post(`${API_URL}/verifyOTP`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Google SSO Login
  googleSSO: async (idToken, userData, deviceId = '', deviceToken = '') => {
    const requestData = {
      username: userData.name || '',
      email: userData.email || '',
      phone: userData.phone || '',
      deviceToken: deviceToken,
      deviceId: deviceId,
      idToken: idToken,
      deviceType: 'web'
    };

    const response = await axios.post(`${API_URL}/sso_login`, requestData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      timeout: 10000,
    });
    return response.data;
  },

  // Forgot Password
  forgotPassword: async (email) => {
    const formData = new FormData();
    formData.append('email', email);

    const response = await axios.post(`${API_URL}/forgot`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Reset Password
  resetPassword: async (token, newPassword, confirmPassword) => {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('password', newPassword);
    formData.append('passconf', confirmPassword);

    // Note: Reset password endpoint is on the main site, not mobile_api
    const baseUrl = API_URL.replace('/mobile_api/api', '');
    const response = await axios.post(
      `${baseUrl}/home/reset_password`, 
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
    return response.data;
  },

  // Update Profile
  updateProfile: async (profileData) => {
    const formData = new FormData();
    formData.append('id', profileData.id);
    formData.append('name', profileData.name);
    formData.append('address', profileData.address || '');
    formData.append('mobile', profileData.mobile);

    const response = await axios.post(`${API_URL}/updateProfile`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Change Password
  changePassword: async (userId, currentPassword, newPassword, confirmPassword) => {
    const formData = new FormData();
    formData.append('id', userId);
    formData.append('current_password', currentPassword);
    formData.append('new_password', newPassword);
    formData.append('confirm_password', confirmPassword);

    const response = await axios.post(`${API_URL}/changePassword`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Logout
  logout: async (userId) => {
    const formData = new FormData();
    formData.append('user_id', userId);

    const response = await axios.post(`${API_URL}/logout`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Check Email Availability
  checkEmail: async (email) => {
    const formData = new FormData();
    formData.append('email', email);

    const response = await axios.post(`${API_URL}/checkEmailAvailibility`, formData);
    return response.data;
  },
};

